globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
var dropdownOptionsStyle = {
  "position": "absolute",
  "zIndex": "50",
  "marginTop": "0.5rem",
  "maxHeight": "304px",
  "width": "100%",
  "overflow": "auto",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "padding": "0.5rem",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "--tw-shadow": "0px 4px 16px 0px rgba(0, 0, 26, 0.25)",
  "--tw-shadow-colored": "0px 4px 16px 0px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
  "scrollbarWidth": "none",
  "::-webkit-scrollbar": {
    "display": "none"
  }
};
var dropdownOptionStyle = {
  "position": "relative",
  "display": "flex",
  "cursor": "pointer",
  "userSelect": "none",
  "alignItems": "center",
  "paddingTop": "0px",
  "paddingBottom": "0px",
  "paddingLeft": "1.25rem",
  "paddingRight": "1.25rem",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))",
  ":hover": {
    "borderRadius": "0.5rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(235 235 237 / var(--tw-bg-opacity))"
  }
};
export var DropdownWrapper = /*#__PURE__*/_styled.ul.withConfig({
  displayName: "google-auto-complete-inputstyles__DropdownWrapper",
  componentId: "sc-1i0b6sk-0"
})(["", ";", ";"], {
  "display": "flex",
  "maxHeight": "18rem",
  "minHeight": "14rem",
  "flexDirection": "column",
  "gap": "0.75rem",
  "overflowY": "auto",
  "padding": "1rem"
}, function (_ref) {
  var dropdownSubWrapperStyle = _ref.dropdownSubWrapperStyle;
  return dropdownSubWrapperStyle;
});
export var GoogleAutoCompleteAddressItemStyled = /*#__PURE__*/_styled.li.withConfig({
  displayName: "google-auto-complete-inputstyles__GoogleAutoCompleteAddressItemStyled",
  componentId: "sc-1i0b6sk-1"
})(["", ";", ";", ";", ";", ""], {
  "display": "flex",
  "width": "100%",
  "cursor": "pointer",
  "alignItems": "center",
  "justifyContent": "space-between"
}, {
  "paddingTop": "0.625rem",
  "paddingBottom": "0.625rem"
}, function (_ref2) {
  var dropdownItemStyle = _ref2.dropdownItemStyle;
  return dropdownItemStyle;
}, function (_ref3) {
  var isActive = _ref3.isActive,
      activeItemStyle = _ref3.activeItemStyle;
  return isActive ? activeItemStyle : '';
}, [dropdownOptionStyle, {
  "marginTop": "0.75rem",
  "marginBottom": "0.75rem",
  "minHeight": "fit-content",
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem",
  "paddingLeft": "0px",
  "paddingRight": "0px",
  "@media (min-width: 1024px)": {
    "marginTop": "0.25rem",
    "marginBottom": "0.25rem",
    "paddingLeft": "0.5rem",
    "paddingRight": "0.5rem",
    "paddingTop": "0.5rem",
    "paddingBottom": "0.5rem"
  }
}]);
export var DropdownElementWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "google-auto-complete-inputstyles__DropdownElementWrapper",
  componentId: "sc-1i0b6sk-2"
})(["", " ", ";"], {
  "position": "absolute",
  "left": "0px",
  "zIndex": "10",
  "width": "100%",
  "maxWidth": "37.5rem",
  "borderRadius": "0.375rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "--tw-shadow": "0px 4px 16px 0px rgba(0, 0, 26, 0.50)",
  "--tw-shadow-colored": "0px 4px 16px 0px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
}, function (_ref4) {
  var dropdownMainWrapperStyle = _ref4.dropdownMainWrapperStyle;
  return [dropdownOptionsStyle, dropdownMainWrapperStyle || {}];
});
export var MainWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "google-auto-complete-inputstyles__MainWrapper",
  componentId: "sc-1i0b6sk-3"
})(["", ";"], function (_ref5) {
  var mainWrapperStyle = _ref5.mainWrapperStyle;
  return mainWrapperStyle;
});